// Mock data for HoosYer Helper LLC website

export const services = [
  {
    id: 1,
    title: "Full Construction",
    description: "Ground-up construction services for residential and commercial projects. Our experienced team manages every phase from initial site preparation and foundation work through final finishes. We work closely with clients throughout the entire build process, providing regular updates and ensuring your vision becomes reality. From obtaining permits to final inspections, we handle all aspects so you can focus on your future in your new space. We bring our mobile capabilities to your location anywhere in Indiana.",
    icon: "Building2",
    image: "https://images.unsplash.com/photo-1541888946425-d81bb19240f5",
    features: ["New Home Construction", "Commercial Buildings", "Additions & Extensions", "Structural Renovations"]
  },
  {
    id: 2,
    title: "Excavation & Dirt Work",
    description: "Professional excavation services with state-of-the-art equipment and experienced operators. We assess your land, create detailed grading plans, and execute precise excavation work for foundations, utilities, driveways, and landscaping. Our team ensures proper drainage, soil compaction, and site preparation that meets all engineering specifications. We work efficiently to minimize project timelines while maintaining the highest safety standards. Our mobile excavation equipment travels throughout Indiana to serve you on-site.",
    icon: "Wrench",
    image: "https://images.unsplash.com/photo-1622082679766-c5912d9416eb",
    features: ["Site Preparation", "Land Grading", "Trenching", "Foundation Excavation"]
  },
  {
    id: 3,
    title: "Handyman Services",
    description: "Comprehensive handyman services for repairs, maintenance, and home improvements of all sizes. No job is too small for our skilled craftsmen. We arrive on time, assess the work needed, provide honest estimates, and complete projects efficiently. From fixing a leaky faucet to installing new fixtures, our versatile team handles it all with professionalism and attention to detail, ensuring your home stays in perfect condition. We're mobile and ready to come to you anywhere in Indiana.",
    icon: "Hammer",
    image: "https://images.unsplash.com/photo-1615856210162-9ae33390b1a2",
    features: ["Home Repairs", "Painting & Drywall", "Plumbing Fixes", "Electrical Work"]
  },
  {
    id: 4,
    title: "Remodeling",
    description: "Transform your existing space with our expert remodeling services. We begin with detailed consultations to understand your vision, lifestyle needs, and budget. Our designers create practical layouts that maximize space and functionality. Throughout construction, we maintain clean work areas, protect your home, and keep you informed of progress. From concept to completion, we deliver remodels that exceed expectations and add lasting value to your property. Our mobile team brings all necessary tools and expertise directly to your location.",
    icon: "Home",
    image: "https://images.pexels.com/photos/159045/the-interior-of-the-repair-interior-design-159045.jpeg",
    features: ["Kitchen Remodeling", "Bathroom Renovation", "Basement Finishing", "Interior Updates"]
  },
  {
    id: 5,
    title: "Roofing Services",
    description: "Professional roofing installation, repair, and maintenance to protect your most valuable investment. Our certified roofers conduct thorough inspections, provide detailed assessments, and recommend the best solutions for your specific situation. We use premium materials, follow manufacturer specifications, and stand behind our work with comprehensive warranties. From minor leak repairs to complete roof replacements, we ensure your home stays dry and protected for years to come. We're mobile and serve all of Indiana.",
    icon: "Triangle",
    image: "https://images.unsplash.com/photo-1635424824849-1b09bdcc55b1",
    features: ["Roof Installation", "Roof Repairs", "Gutter Services", "Roof Inspections"]
  },
  {
    id: 6,
    title: "Deck & Patio",
    description: "Create beautiful outdoor living spaces with custom deck and patio construction. We help you design the perfect outdoor area for entertaining, relaxing, and enjoying Indiana's seasons. Our team uses quality lumber, composite materials, or pavers suited to your preferences and budget. We ensure proper structural support, drainage, and finishing that withstands weather and provides years of enjoyment. From simple platforms to elaborate multi-level entertainment areas, we build outdoor spaces you'll love. Mobile service available statewide.",
    icon: "Square",
    image: "https://images.unsplash.com/photo-1626081063434-79a2169791b1",
    features: ["Deck Construction", "Patio Installation", "Outdoor Kitchens", "Pergolas & Gazebos"]
  },
  {
    id: 7,
    title: "Flooring Installation",
    description: "Professional flooring installation and refinishing services that transform your space from the ground up. We help you select the perfect flooring material for each room's unique needs and traffic patterns. Our skilled installers prepare subfloors properly, ensure level surfaces, and install with precision. Whether you prefer the warmth of hardwood, durability of tile, comfort of carpet, or convenience of laminate, we deliver flawless installations with clean, professional results. Mobile flooring services throughout Indiana.",
    icon: "Layers",
    image: "https://images.unsplash.com/photo-1575204015311-0fe377370780",
    features: ["Hardwood Flooring", "Tile Installation", "Carpet Installation", "Floor Refinishing"]
  },
  {
    id: 8,
    title: "Painting Services",
    description: "Interior and exterior painting services that breathe new life into your property. Our professional painters properly prepare all surfaces, repair imperfections, and apply premium paints with expert technique. We protect your furnishings, maintain clean work areas, and respect your daily routine. From color consultation to final touch-ups, we deliver smooth, even finishes that enhance your space and withstand the test of time. Your satisfaction is our priority on every project. We're mobile and come to you anywhere in Indiana.",
    icon: "Paintbrush",
    image: "https://images.unsplash.com/photo-1738817628138-b794ed944ed5",
    features: ["Interior Painting", "Exterior Painting", "Cabinet Refinishing", "Staining & Sealing"]
  },
  {
    id: 9,
    title: "Concrete Work",
    description: "Durable concrete solutions for driveways, sidewalks, patios, and foundations. Our experienced concrete crews properly prepare sites, create accurate forms, and pour quality concrete mixed to precise specifications. We pay careful attention to slope, drainage, control joints, and finishing techniques that prevent cracking and ensure longevity. Whether you need a simple walkway or complex stamped concrete patio, we deliver solid, long-lasting results that enhance your property's functionality and curb appeal. Mobile concrete services statewide.",
    icon: "Box",
    image: "https://images.unsplash.com/photo-1558227691-41ea78d1f631",
    features: ["Driveways", "Sidewalks", "Concrete Patios", "Foundation Work"]
  },
  {
    id: 10,
    title: "Window & Door Installation",
    description: "Energy-efficient window and door installation that improves comfort, security, and curb appeal. We help you select quality products that fit your home's style and performance needs. Our installers remove old units carefully, ensure proper framing, and install new windows and doors with precision sealing and insulation. We guarantee weather-tight installations that reduce energy costs, eliminate drafts, and enhance your home's appearance and value for years to come. Mobile installation service available throughout Indiana.",
    icon: "DoorOpen",
    image: "https://images.pexels.com/photos/368754/pexels-photo-368754.jpeg",
    features: ["Window Installation", "Door Replacement", "Storm Doors", "Sliding Doors"]
  },
  {
    id: 11,
    title: "Carpentry Services",
    description: "Expert carpentry for custom projects, repairs, and fine finishing work. Our skilled carpenters measure precisely, cut accurately, and assemble with meticulous attention to detail. Whether crafting custom cabinetry, installing intricate trim work, building functional shelving, or framing structural additions, we bring craftsmanship and pride to every project. We use quality materials, professional techniques, and ensure every joint, miter, and finish meets the highest standards of woodworking excellence. We're mobile and serve all of Indiana.",
    icon: "Ruler",
    image: "https://images.unsplash.com/photo-1645651964715-d200ce0939cc",
    features: ["Custom Cabinetry", "Trim & Molding", "Built-in Shelving", "Structural Framing"]
  },
  {
    id: 12,
    title: "Masonry Services",
    description: "Professional masonry for brick, stone, and block work that stands the test of time. Our experienced masons skillfully lay each unit with proper mortar consistency, joint spacing, and structural integrity. From stunning outdoor fireplaces to solid retaining walls, functional chimneys to elegant walkways, we combine traditional craftsmanship with modern techniques. We select quality materials, ensure proper drainage and support, and deliver masonry work that adds beauty, value, and permanence to your property. Mobile masonry services available statewide.",
    icon: "Blocks",
    image: "https://images.unsplash.com/photo-1694521787193-9293daeddbaa",
    features: ["Brick & Stone Work", "Retaining Walls", "Fireplace Installation", "Chimney Repair"]
  },
  {
    id: 13,
    title: "Siding Installation",
    description: "Protect and beautify your home with professional siding installation. We inspect your home's exterior, recommend the best siding material for your climate and budget, and install with meticulous attention to weather resistance and ventilation. Our team ensures proper moisture barriers, tight seams, and precise trim work that protects your home from the elements while dramatically improving its appearance. Quality siding installation provides lasting protection and instant curb appeal. We're mobile and serve all of Indiana.",
    icon: "PanelTop",
    image: "https://images.unsplash.com/photo-1635424709845-3a85ad5e1f5e",
    features: ["Vinyl Siding", "Fiber Cement", "Wood Siding", "Siding Repair"]
  },
  {
    id: 14,
    title: "Fencing Services",
    description: "Custom fence installation for privacy, security, and property definition. We help you select the right fence style and material for your needs and local regulations. Our installers set posts to proper depth in concrete, ensure level rails, and attach boards or panels with precision. We create gates that operate smoothly and latch securely. From elegant privacy fences to functional chain-link, we deliver durable, attractive fencing that defines your space and provides peace of mind. Mobile fencing services throughout Indiana.",
    icon: "Fence",
    image: "https://images.pexels.com/photos/1094770/pexels-photo-1094770.jpeg",
    features: ["Wood Fencing", "Vinyl Fencing", "Chain-Link", "Fence Repair"]
  },
  {
    id: 15,
    title: "Demolition Services",
    description: "Safe and efficient demolition services for residential and commercial projects. Our trained crews follow strict safety protocols, obtain necessary permits, and methodically dismantle structures while protecting surrounding property. We disconnect utilities properly, contain dust and debris, sort materials for recycling when possible, and provide thorough site cleanup. Whether removing a single wall or entire structure, we execute controlled demolition that prepares your site for the next phase of construction. Mobile demolition services available statewide.",
    icon: "Trash2",
    image: "https://images.unsplash.com/photo-1626885930974-4b69aa21bbf9",
    features: ["Interior Demolition", "Structure Removal", "Site Cleanup", "Debris Hauling"]
  },
  {
    id: 16,
    title: "Landscaping",
    description: "Transform your outdoor space with professional landscaping design, installation, and maintenance. We assess your property's unique characteristics, discuss your vision and lifestyle needs, and create landscapes that enhance beauty and functionality. Our team expertly installs plants suited to Indiana's climate, grades for proper drainage, and incorporates hardscaping elements. From lush garden beds to sophisticated outdoor lighting, we create landscapes that increase property value and provide year-round enjoyment. We're mobile and come to you.",
    icon: "TreePine",
    image: "https://images.unsplash.com/photo-1630288214173-a119cf823388",
    features: ["Landscape Design", "Lawn Installation", "Garden Beds", "Outdoor Lighting"]
  },
  {
    id: 17,
    title: "Plumbing Services",
    description: "Licensed plumbing services for installations, repairs, and maintenance. Our experienced plumbers diagnose issues accurately, explain options clearly, and complete work to code. We arrive with well-stocked trucks, use quality fixtures and materials, and stand behind our work. From fixing annoying leaks to installing complete bathroom systems, upgrading water heaters to clearing stubborn drains, we solve your plumbing problems efficiently and professionally, ensuring everything flows properly and safely. Mobile plumbing services statewide.",
    icon: "Droplet",
    image: "https://images.pexels.com/photos/1216589/pexels-photo-1216589.jpeg",
    features: ["Leak Repairs", "Fixture Installation", "Drain Cleaning", "Water Heater Service"]
  },
  {
    id: 18,
    title: "Sandblasting Services",
    description: "Professional sandblasting for surface preparation, cleaning, and restoration. Our skilled operators use appropriate abrasive media and controlled pressure to remove rust, old paint, and contaminants without damaging underlying surfaces. We properly contain blast areas, protect surrounding property, and thoroughly clean up afterward. Whether preparing metal for coating, restoring brick facades, or cleaning concrete, we deliver surfaces perfectly prepared for refinishing, ensuring long-lasting results for your next coating or finish. Mobile sandblasting throughout Indiana.",
    icon: "Wind",
    image: "https://images.unsplash.com/photo-1601058268499-e52658b8bb88",
    features: ["Surface Preparation", "Rust Removal", "Paint Stripping", "Concrete Cleaning"]
  },
  {
    id: 19,
    title: "Commercial Painting & Coatings",
    description: "Industrial-grade painting and protective coatings for commercial and industrial projects. We understand business operations can't stop, so we schedule work to minimize disruption. Our commercial painters use professional equipment, premium products, and efficient techniques to complete projects on time and on budget. We apply protective coatings that withstand harsh environments, follow safety protocols, and deliver durable finishes that maintain appearance and protect your investment for years to come. Mobile commercial services throughout Indiana.",
    icon: "Factory",
    image: "https://images.unsplash.com/photo-1738817628138-b794ed944ed5",
    features: ["Industrial Painting", "Protective Coatings", "Commercial Projects", "Surface Protection"]
  },
  {
    id: 20,
    title: "Welding Services",
    description: "Expert welding for structural, decorative, and repair projects. Our certified welders bring years of experience and precision to every job. We work with various metals and welding processes to create strong, lasting welds for structural supports, custom fabrications, decorative metalwork, and emergency repairs. Whether building custom gates, repairing equipment, fabricating structural steel, or creating one-of-a-kind metal projects, we deliver quality welds that meet or exceed code requirements and stand the test of time. We're mobile and come to your location anywhere in Indiana.",
    icon: "Flame",
    image: "https://images.unsplash.com/photo-1504328345606-18bbc8c9d7d1",
    features: ["Structural Welding", "Metal Fabrication", "Repair Welding", "Custom Metalwork"]
  },
  {
    id: 21,
    title: "Custom Design & Fabrication",
    description: "Bring your unique vision to life with our custom design and fabrication services. No idea is too ambitious or too far-fetched for our creative team. We listen carefully to your concept, create detailed plans, and skillfully fabricate using wood, metal, concrete, or mixed materials. From artistic sculptures to functional structures, unique furniture to architectural features, we combine craftsmanship, creativity, and problem-solving to turn your imagination into reality. Your dream project is our exciting challenge. Mobile custom fabrication services statewide.",
    icon: "Lightbulb",
    image: "https://images.pexels.com/photos/73833/weld-hot-soldering-radio-welder-73833.jpeg",
    features: ["Custom Designs", "Multi-Material Work", "Unique Projects", "Creative Solutions"]
  },
  {
    id: 22,
    title: "Restaurant & Gas Station Remodeling",
    description: "Specialized commercial remodeling for restaurants and gas stations with minimal business disruption. We understand every day closed means lost revenue, so we plan carefully, work efficiently, and often schedule work during off-hours. Our experienced team handles everything from kitchen equipment installation to dining area renovations, fuel system compliance to convenience store updates. We coordinate inspections, ensure code compliance, and deliver functional, attractive spaces that serve customers well and enhance your business operations. Mobile commercial remodeling throughout Indiana.",
    icon: "Store",
    image: "https://images.pexels.com/photos/6082133/pexels-photo-6082133.jpeg",
    features: ["Restaurant Renovations", "Gas Station Upgrades", "Commercial Kitchen Remodels", "Minimal Business Disruption"]
  },
  {
    id: 23,
    title: "RV & Camper Repairs",
    description: "Expert RV and camper repair services to keep your mobile home adventure-ready. Our technicians understand the unique construction and systems of recreational vehicles. We repair water damage, fix electrical issues, patch roofs, update interiors, and modify layouts to better suit your travel lifestyle. From minor repairs to major renovations, we work efficiently to get you back on the road. We use RV-specific materials, ensure proper sealing and ventilation, and help extend the life of your investment. We're mobile and come to you anywhere in Indiana.",
    icon: "Truck",
    image: "https://images.pexels.com/photos/7476922/pexels-photo-7476922.jpeg",
    features: ["Interior Repairs", "Exterior Maintenance", "Water & Electrical Systems", "Custom Modifications"]
  },
  {
    id: 24,
    title: "Hauling & Transport Services",
    description: "Professional hauling and transport services for construction materials, equipment, and project debris. Our dump trailers efficiently move soil, gravel, demolition debris, and bulk materials. Our 25-foot deck-over trailers safely transport heavy equipment, vehicles, building materials, and oversized items. We load carefully, secure properly, transport safely, and unload precisely where you need it. Whether moving materials to your job site or hauling away debris, we provide reliable transport that keeps your project moving forward on schedule. Mobile hauling services throughout Indiana.",
    icon: "Container",
    image: "https://images.pexels.com/photos/2199293/pexels-photo-2199293.jpeg",
    features: ["Dump Trailer Service", "25-Foot Deck Over Trailer", "Heavy Equipment Transport", "Construction Material Hauling"]
  },
  {
    id: 25,
    title: "Snow Removal",
    description: "Professional snow removal and ice management services to keep your property safe and accessible throughout Indiana winters. Our experienced crews respond quickly to winter storms with commercial-grade equipment including plows, snow blowers, and ice control materials. We provide residential driveway clearing, commercial parking lot plowing, sidewalk snow removal, and comprehensive ice management. Available 24/7 during winter weather events, we monitor forecasts and proactively schedule service to ensure your property is clear when you need it. From single driveways to large commercial complexes, we handle snow removal efficiently and thoroughly. Mobile winter service throughout Indiana.",
    icon: "Snowflake",
    image: "https://images.unsplash.com/photo-1491002052546-bf38f186af56",
    features: ["Residential Snow Plowing", "Commercial Lot Clearing", "Sidewalk & Walkway Clearing", "Ice Control & Management"]
  },
  {
    id: 26,
    title: "Pole Barns & Barn Conversions",
    description: "Expert pole barn construction, barn homes, and old barn conversions for residential, agricultural, and event venue purposes. We design and build durable pole barns for storage, workshops, livestock, and equipment. Our specialty includes transforming old barns into stunning event centers perfect for weddings, receptions, and special gatherings while preserving rustic charm and character. We also create beautiful barn-style homes that combine traditional aesthetics with modern comfort and efficiency. From foundation and framing to electrical, HVAC, and finishing work, we handle every aspect of your barn project. Whether building new or renovating historic structures, we deliver functional, attractive spaces that honor barn heritage while meeting today's needs. Mobile barn construction and conversion services statewide.",
    icon: "Warehouse",
    image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa",
    features: ["New Pole Barn Construction", "Barn Home Building", "Event Center Conversions", "Historic Barn Restoration"]
  },
  {
    id: 27,
    title: "Emergency Services",
    description: "24/7 emergency services for urgent repairs when disaster strikes. We understand emergencies don't wait for business hours. Our on-call team responds quickly to storm damage, water leaks, structural failures, and other urgent situations. We assess damage immediately, provide temporary protection, and begin permanent repairs as soon as possible. Available day or night, weekends and holidays, we're here when you need us most to minimize damage, secure your property, and restore safety and functionality fast. Mobile emergency response across all of Indiana.",
    icon: "Phone",
    image: "https://images.unsplash.com/photo-1455165814004-1126a7199f9b",
    features: ["24/7 Availability", "Storm Damage", "Water Damage", "Urgent Repairs"]
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    location: "Indianapolis, IN",
    rating: 5,
    text: "HoosYer Helper completely transformed our kitchen! Their attention to detail and professionalism was outstanding. Highly recommend!",
    service: "Kitchen Remodeling"
  },
  {
    id: 2,
    name: "Mike Thompson",
    location: "Fort Wayne, IN",
    rating: 5,
    text: "Needed emergency roof repair after a storm. They came out within hours and had it fixed the same day. Excellent service!",
    service: "Emergency Roofing"
  },
  {
    id: 3,
    name: "Jennifer Martinez",
    location: "Fishers, IN",
    rating: 5,
    text: "Built our dream home from the ground up. The team was professional, kept us informed, and delivered exactly what we wanted.",
    service: "New Construction"
  },
  {
    id: 4,
    name: "David Chen",
    location: "Bloomington, IN",
    rating: 4,
    text: "Great excavation work for our new driveway. Fair pricing and showed up on time. Work was completed ahead of schedule. Would have been 5 stars but there was a small miscommunication about the timeline initially.",
    service: "Excavation"
  },
  {
    id: 5,
    name: "Lisa Anderson",
    location: "Evansville, IN",
    rating: 5,
    text: "Used their handyman services for various repairs around the house. Quick, efficient, and reasonably priced. Will use again!",
    service: "Handyman Services"
  },
  {
    id: 6,
    name: "Robert Williams",
    location: "Carmel, IN",
    rating: 5,
    text: "Professional team that takes pride in their work. Our basement renovation turned out better than we imagined!",
    service: "Basement Remodeling"
  },
  {
    id: 7,
    name: "Emily Parker",
    location: "South Bend, IN",
    rating: 4,
    text: "Very happy with the deck they built for us. Quality craftsmanship and the workers were friendly. Only minor issue was a slight delay due to weather, but they communicated well about it.",
    service: "Deck Construction"
  },
  {
    id: 8,
    name: "James Mitchell",
    location: "Muncie, IN",
    rating: 5,
    text: "Had them weld custom railings for our commercial property. Absolutely stunning work! Their welding expertise is top-notch.",
    service: "Welding Services"
  },
  {
    id: 9,
    name: "Patricia Rodriguez",
    location: "Lafayette, IN",
    rating: 3,
    text: "The painting job was okay. The quality of work was good but it took a bit longer than estimated. Price was fair though and they did fix a couple spots we pointed out.",
    service: "Interior Painting"
  },
  {
    id: 10,
    name: "Kevin Brown",
    location: "Terre Haute, IN",
    rating: 5,
    text: "Hired them for sandblasting our old brick building. Transformed it completely! Very professional and cleaned up thoroughly after the job.",
    service: "Sandblasting"
  },
  {
    id: 11,
    name: "Amanda Foster",
    location: "Hammond, IN",
    rating: 5,
    text: "Amazing custom fabrication work! They built a one-of-a-kind metal art piece for our restaurant entrance. Their creativity and skill are incredible!",
    service: "Custom Fabrication"
  },
  {
    id: 12,
    name: "Thomas Wright",
    location: "Gary, IN",
    rating: 4,
    text: "Good experience overall with our commercial coating project. The protective coating looks great and the team was professional. Slight scheduling hiccup at the start but they made it right.",
    service: "Commercial Coatings"
  },
  {
    id: 13,
    name: "Michelle Davis",
    location: "Kokomo, IN",
    rating: 5,
    text: "Best flooring installation I've ever seen! The hardwood floors are absolutely beautiful and the installers were meticulous with their work.",
    service: "Flooring Installation"
  },
  {
    id: 14,
    name: "Christopher Lee",
    location: "Anderson, IN",
    rating: 5,
    text: "Excellent masonry work on our outdoor fireplace and patio. Solid craftsmanship that will last for decades. Worth every penny!",
    service: "Masonry Services"
  },
  {
    id: 15,
    name: "Rebecca Taylor",
    location: "Noblesville, IN",
    rating: 4,
    text: "Happy with the carpentry work on our built-in cabinets. Beautiful craftsmanship. Communication could have been a bit better during the project, but the end result is great.",
    service: "Carpentry Services"
  }
];

export const galleryImages = [
  {
    id: 1,
    url: "https://lh3.googleusercontent.com/pw/AP1GczOXwQFOWo1rxsTlPpMWqZu0si8E-hUx1JUBwvKUJhPx3_PlrmKjr4JvvVpUoz1KyM6q7Qgp8dpuHUdxOhNvtmJWEIj8ky-gpzOGP4EobilebaW0M9MG=w1200-h900-no",
    title: "HoosYer Helper Construction Project",
    category: "construction"
  },
  {
    id: 2,
    url: "https://lh3.googleusercontent.com/pw/AP1GczMWXKsXH47ISObRKYoHWu3FHD3Pn4v5AW8B8rtID0IMbTTx7oXMVgibJg36EpNl5hON5XNx8r1561rRPwXO76yhTC0g-roRTExibAFgTDRSf4c6z9d6=w1200-h900-no",
    title: "Professional Construction Work",
    category: "construction"
  },
  {
    id: 3,
    url: "https://lh3.googleusercontent.com/pw/AP1GczPx2_VCFQq-RZBaZIajalsB1CEG0Ovn9MjnpN1p3yoIAiPsezOxm48B3GlAl9zAyBsXwR37gb7prkCs7ez4b1eoLOOqRYyez-ozG8nB58yD_AZblRwC=w1200-h900-no",
    title: "Quality Craftsmanship",
    category: "handyman"
  },
  {
    id: 4,
    url: "https://lh3.googleusercontent.com/pw/AP1GczPFGa_UeCIH48qtBc8Zz_PUtnZMiCDLed2_yAcWtkothcvDtP-ywjLoHc_XeWRlLtMza7aDk5F98YhJhFA9AQC4qmSJq4c1bj4royR6WOsbuXxyeieF=w1200-h900-no",
    title: "Expert Handyman Services",
    category: "handyman"
  },
  {
    id: 5,
    url: "https://lh3.googleusercontent.com/pw/AP1GczMpWBMgiVBdiMURlkG9EqMHGhgMdh_t9YI5f7_UT5TWAkmlVvxUMFkxX0nBj1-Czz9-YQwxYa1TJnfaZA0xhcfLWxU8_HhqvNK6RjiWGOnHU6XT_rZX=w1200-h900-no",
    title: "Professional Installation",
    category: "construction"
  },
  {
    id: 6,
    url: "https://lh3.googleusercontent.com/pw/AP1GczMLQREqF_Bdcn5smb4tGZLYr89afDSYuxP6pNYNC-8gM1lzcWnPgENfCch-MdOHyygPl13AiD-BG4YvjZ34lLKv6-rifq3eJsJYBN25oflGiIz0MBDa=w1200-h900-no",
    title: "Detailed Work",
    category: "construction"
  },
  {
    id: 7,
    url: "https://lh3.googleusercontent.com/pw/AP1GczM-ZGQA8abN2GQDkiuzEb5brD_Dtt6GVG3abZz5jlzD2NJ3jVZowAgZUd77TxPqTuut150AXuk_FFQavByi64VPeLD1Efy0qDebN_Gx3F0_JdksTIc-=w1200-h900-no",
    title: "Construction Excellence",
    category: "construction"
  },
  {
    id: 8,
    url: "https://lh3.googleusercontent.com/pw/AP1GczN1MvoPpAiPhDYkAoH4cmI-isFSo5Oq3fdnDHovm3c3iTsgnuCm8NDboDIfxQzLAxh9EF42CF2QkBql6DUidROa88Yo_Q3g0MIoQ27a5538WRz3ksnO=w1200-h900-no",
    title: "Skilled Craftsmanship",
    category: "handyman"
  },
  {
    id: 9,
    url: "https://lh3.googleusercontent.com/pw/AP1GczOD27IlYmA_J1P-dZ96BTzzi57KYKjDQ2LpE7j3Uc9z3HJXNrJfAMR-mA-STxIMZY4MK6g1tod-ss2vENQO5c3EZKBBVkvlU-kGsMD6-eEfHBC2rV_D=w1200-h900-no",
    title: "Quality Work Guaranteed",
    category: "construction"
  },
  {
    id: 10,
    url: "https://lh3.googleusercontent.com/pw/AP1GczMdXC2Op6y4iHwimsTZlBu2jkfAN3kEx_MALRngt0k7454hGZS_U5PEW6rcOg-8Xx2tLMwzX97lfaB9BbGpHXnPEQSSqJRbWDE2rh9zzxKBQlG1wJD7=w1200-h900-no",
    title: "Professional Results",
    category: "construction"
  }
];

export const certifications = [
  {
    id: 1,
    name: "Licensed General Contractor",
    issuer: "State of Indiana",
    icon: "Award"
  },
  {
    id: 2,
    name: "Insured & Bonded",
    issuer: "Full Coverage",
    icon: "Shield"
  },
  {
    id: 3,
    name: "OSHA Certified",
    issuer: "Safety Compliance",
    icon: "CheckCircle"
  },
  {
    id: 4,
    name: "BBB A+ Rating",
    issuer: "Better Business Bureau",
    icon: "Star"
  }
];

export const serviceAreas = [
  "Statewide Service - All of Indiana",
  "Indianapolis",
  "Fort Wayne", 
  "Evansville",
  "South Bend",
  "Carmel",
  "Fishers",
  "Bloomington",
  "Hammond",
  "Gary",
  "Lafayette",
  "Muncie",
  "Terre Haute",
  "Kokomo",
  "Anderson",
  "Noblesville",
  "Greenwood",
  "Elkhart",
  "Mishawaka",
  "Lawrence"
];

export const teamMembers = [
  {
    id: 1,
    name: "Wade Murphy",
    title: "Owner / Operator",
    image: "https://lh3.googleusercontent.com/pw/AP1GczMjGhYYalZcNaya9kd7edcN_3VQXWVPtFYMI6a2pyeEsHoiJ4cgQ6DG_e4VX4kiYodBEeBaPgYVFdLkOn-Q4SqFI0YnQsg5CeegwWP8uAiL17YKVzJW=w1200-h1400-no",
    bio: "Wade Murphy is the visionary founder and hands-on owner of HoosYer Helper LLC. With over 30 years of experience in the construction industry, Wade doesn't just manage from behind a desk—he's on-site, working alongside his team, ensuring every project meets his exceptionally high standards. His commitment to excellence is unmatched, often working day and night to bring his clients' dreams to reality. Wade's philosophy is simple: no idea is too ambitious, no project too challenging. His dedication to transforming concepts into tangible results has made HoosYer Helper a trusted name throughout Indiana.",
    achievements: [
      "30+ years of construction excellence",
      "Licensed General Contractor",
      "Built HoosYer Helper from the ground up",
      "Personally oversees major projects",
      "Available 24/7 for client needs and concerns",
      "Known for returning every client call within hours",
      "Maintains personal relationships with clients long after project completion",
      "Goes above and beyond—often working nights and weekends to meet client deadlines",
      "Countless referrals from satisfied clients who became lifelong advocates",
      "Never says 'no' to a client's vision—finds solutions to make it happen",
      "Personally ensures quality on every job site, big or small",
      "Built company reputation on client satisfaction, not profit margins"
    ],
    quote: "I don't just build structures—I build relationships and bring visions to life. Every client's dream is my mission."
  },
  {
    id: 2,
    name: "Seth Murphy",
    title: "Operations Manager",
    image: "https://customer-assets.emergentagent.com/job_handy-constructors/artifacts/pbbsuzqu_IMG_20260112_180421.jpg",
    bio: "Seth Murphy joined the HoosYer Helper family in 2013 and has become an extraordinary force driving the company's success and growth. As Operations Manager, Seth combines exceptional technical expertise with outstanding leadership abilities and an unwavering commitment to client satisfaction. His talent for coordinating complex multi-phase projects, managing diverse teams with efficiency and respect, and solving challenges with innovative solutions has elevated HoosYer Helper's reputation throughout Indiana. Seth's dedication goes beyond management—he's personally invested in every client's success, often going the extra mile to ensure projects exceed expectations. His strategic vision, operational excellence, and genuine care for both clients and team members make him an invaluable asset and a cornerstone of HoosYer Helper's continued expansion and prosperity over the next 30 years.",
    achievements: [
      "12 years of exceptional service since 2013",
      "Increased operational efficiency by 40%",
      "Led company expansion to statewide service coverage",
      "Implemented quality control systems that reduced callbacks by 60%",
      "Mentored and developed next generation of skilled craftsmen",
      "Achieved 98% client satisfaction rating",
      "Key architect of company's strategic growth and diversification",
      "Champion of safety protocols—zero major incidents under his leadership"
    ],
    quote: "I'm here for our clients, every step of the way. Their success is our success, and I'm committed to making every project exceptional."
  }
];

export const faqs = [
  {
    id: 1,
    question: "Do you offer free estimates?",
    answer: "Yes! We provide free, no-obligation estimates for all our services. Contact us today to schedule an on-site evaluation."
  },
  {
    id: 2,
    question: "Are you licensed and insured?",
    answer: "Absolutely. We are a fully licensed general contractor in the state of Indiana, and we carry comprehensive insurance and bonding for your protection."
  },
  {
    id: 3,
    question: "Do you handle emergency repairs?",
    answer: "Yes, we offer 24/7 emergency services for urgent repairs including storm damage, water damage, and other time-sensitive issues."
  },
  {
    id: 4,
    question: "What areas do you serve?",
    answer: "We proudly serve all of Indiana! From Indianapolis to Fort Wayne, Evansville to South Bend, and everywhere in between. No project is too far for our experienced team."
  },
  {
    id: 5,
    question: "How long have you been in business?",
    answer: "HoosYer Helper LLC has been proudly serving Indiana with quality construction and handyman services for over 30 years. Our experience and reputation speak for themselves."
  },
  {
    id: 6,
    question: "Do you offer warranties on your work?",
    answer: "Yes, we stand behind our work with comprehensive warranties. Specific warranty terms vary by project type and will be detailed in your contract."
  }
];